type SourceAvatarProps = {
  label: string
  children: React.ReactNode
}

export const SourceAvatar = ({ label, children }: SourceAvatarProps) => (
  <span
    aria-label={label}
    className='flex size-6 items-center justify-center rounded-full border border-main-border-default bg-main-background-card'
  >
    {children}
  </span>
)
